"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;
/**
 * Apply a new format to date arguments
 * The result will be: '<Month Name> <Date Number>, <Year>'
 *
 * Ex: formatDate('2016-07-12T15:08:43.143Z') => 'July 12, 2016'
 *
 * @param {...Object} date
 */

function formatDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  };
  var newDate = new Date(date);
  if (newDate.toString() === 'Invalid Date') {
    return 'Invalid Date';
  }
  return newDate.toLocaleDateString('en-US', format);
}
//# sourceMappingURL=date.js.map